/** @jsx jsx */

import { jsx } from '@emotion/react';
import { Box, xcss } from '@atlaskit/primitives';
var avatarSectionStyles = xcss({
  gridArea: 'avatar-area'
});
/**
 * __Avatar slot is used to nest an avatar in a comment__
 *
 * The avatar slot is used to nest an avatar in a comment's layout.
 *
 */
var AvatarSlot = function AvatarSlot(_ref) {
  var children = _ref.children;
  return jsx(Box, {
    xcss: avatarSectionStyles
  }, children);
};
export default AvatarSlot;